export default "__VITE_ASSET__DKNvh6b2__"